import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full px-2 pb-2"
}
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "flex-1 px-2 space-y-3" }
const _hoisted_5 = { class: "space-y-1" }
const _hoisted_6 = {
  class: "space-y-1",
  role: "group"
}
const _hoisted_7 = {
  key: 0,
  class: "italic px-3 py-1 text-sm tracking-tight text-gray-600"
}
const _hoisted_8 = { class: "space-y-1" }
const _hoisted_9 = {
  class: "space-y-1",
  role: "group"
}
const _hoisted_10 = {
  key: 0,
  class: "italic px-3 py-1 text-sm tracking-tight text-gray-600"
}
const _hoisted_11 = { class: "space-y-1" }
const _hoisted_12 = {
  class: "space-y-1",
  role: "group"
}
const _hoisted_13 = {
  key: 1,
  class: "w-full px-2 pt-2"
}

import { BarsArrowDownIcon, BarsArrowUpIcon } from '@heroicons/vue/20/solid'
import { reactive } from 'vue'
import { computed, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import NeueButton from '@/components/neue/NeueButton'
import SelectInput from '@/components/neue/SelectInput'
import { pairComparator } from '@/helpers/conversationSort'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'

const pageSize = 50


export default {
  __name: 'ConversationsMenu',
  emits: ['add-contact'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const store = useStore()
const router = useRouter()
const route = useRoute()
const sortBy = computed({
  get: () => store.state.conversationSortBy,
  set: val => store.commit('SET_CONVERSATION_SORT_BY', val)
})
const sortDirection = computed({
  get: () => store.state.conversationSortDirection,
  set: val => store.commit('SET_CONVERSATION_SORT_DIRECTION', val)
})

const allPairs = computed(() => {
  const pairs = Object.values(store.state.objects.conversation_user_pair || {})
  return pairs.sort(pairComparator(sortBy.value, sortDirection.value))
})

const unread = computed(() => allPairs.value.filter(x => x.attributes['has_unread?']))
const starred = computed(() => allPairs.value.filter(x => x.attributes['favorited?'] && !x.attributes['has_unread?']))
const rest = computed(() => allPairs.value.filter(x => !x.attributes['favorited?'] && !x.attributes['has_unread?']))
const canCreateMessages = computed(() => {
  return privilegeService.canAccessResourceAction('messages', null, 'create')
})

const pageData = reactive({
  page: 0,
  morePages: true
})

const loadPage = page => {
  api.call('GET', `conversation_user_pairs?limit=${pageSize}&page=${page}`).then(response => {
    if (response.data.data.length !== pageSize) {
      pageData.morePages = false
    }
  })
}

const arrowNav = e => {
  const altArrow = e.altKey && (e.key === 'ArrowUp' || e.key === 'ArrowDown')
  if (!altArrow) return
  e.preventDefault()

  const pairs = [...unread.value, ...starred.value, ...rest.value]
  const index = pairs.findIndex(x => x.id === route.params.id)
  if (e.key === 'ArrowUp') {
    const prevIndex = (pairs.length + index - 1) % pairs.length
    router.replace('/messages/' + pairs[prevIndex].id)
  }
  if (e.key === 'ArrowDown') {
    const nextIndex = (index + 1) % pairs.length
    router.replace('/messages/' + pairs[nextIndex].id)
  }
}

onMounted(() => {
  loadPage(0)
  window.addEventListener('keydown', arrowNav)
})

onUnmounted(() => {
  window.removeEventListener('keydown', arrowNav)
})

return (_ctx, _cache) => {
  const _component_sidebar_conversation = _resolveComponent("sidebar-conversation")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (canCreateMessages.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(NeueButton), {
            type: "secondary",
            class: "w-full",
            onClick: _cache[0] || (_cache[0] = $event => (emit('add-contact')))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "w-full text-center" }, "+ Add contact", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex items-center gap-1.5 px-2 pb-2",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(SelectInput), {
          modelValue: sortBy.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((sortBy).value = $event)),
          slim: "",
          options: [
          { name: 'Recent activity', value: 'recent' },
          { name: 'Alphabetical', value: 'alphabetical' }
        ]
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("button", {
        class: "flex items-center justify-center w-8 h-8 border border-gray-300 rounded-md bg-white text-gray-500 hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand-500",
        title: sortDirection.value === 'desc' ? 'Descending' : 'Ascending',
        onClick: _cache[2] || (_cache[2] = $event => (sortDirection.value = sortDirection.value === 'desc' ? 'asc' : 'desc'))
      }, [
        (sortDirection.value === 'desc')
          ? (_openBlock(), _createBlock(_unref(BarsArrowDownIcon), {
              key: 0,
              class: "w-4 h-4"
            }))
          : (_openBlock(), _createBlock(_unref(BarsArrowUpIcon), {
              key: 1,
              class: "w-4 h-4"
            }))
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("nav", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-full flex items-center rounded-md px-3 py-1 text-md font-bold tracking-tight text-gray-600" }, " Unread ", -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unread.value, (conversationUserPair) => {
            return (_openBlock(), _createBlock(_component_sidebar_conversation, {
              key: conversationUserPair.id,
              "conversation-user-pair": conversationUserPair
            }, null, 8, ["conversation-user-pair"]))
          }), 128)),
          (!unread.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No unread messages "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-full flex items-center rounded-md px-3 py-1 text-md font-bold tracking-tight text-gray-600" }, " Starred ", -1)),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(starred.value, (conversationUserPair) => {
            return (_openBlock(), _createBlock(_component_sidebar_conversation, {
              key: conversationUserPair.id,
              "conversation-user-pair": conversationUserPair
            }, null, 8, ["conversation-user-pair"]))
          }), 128)),
          (!starred.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " No starred conversations "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-full flex items-center rounded-md px-3 py-1 text-md font-bold tracking-tight text-gray-600" }, " All Contacts ", -1)),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rest.value, (conversationUserPair) => {
            return (_openBlock(), _createBlock(_component_sidebar_conversation, {
              key: conversationUserPair.id,
              "conversation-user-pair": conversationUserPair
            }, null, 8, ["conversation-user-pair"]))
          }), 128))
        ])
      ])
    ]),
    (pageData.morePages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_unref(NeueButton), {
            type: "secondary",
            class: "w-full",
            onClick: _cache[4] || (_cache[4] = _withModifiers($event => (loadPage(++pageData.page)), ["stop"]))
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createElementVNode("span", { class: "w-full text-center" }, "Load more", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

}